export default "__VITE_ASSET__4bee9a93__"